export const WhatsAppIcon = () => {
  return (
    <svg viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.987.426C4.395.693-.017 5.35 0 10.946a10.454 10.454 0 001.143 4.736L.028 21.095a.409.409 0 00.495.48l5.302-1.256a10.45 10.45 0 004.512 1.095c5.715.087 10.48-4.45 10.658-10.163C21.185 5.126 16.132.134 9.987.426zm6.327 16.302a8.167 8.167 0 01-5.814 2.408 8.135 8.135 0 01-3.66-.858l-.738-.368-3.25.77.684-3.321-.364-.713a8.13 8.13 0 01-.894-3.732c0-2.196.856-4.26 2.408-5.813A8.236 8.236 0 0110.5 2.692c2.196 0 4.26.856 5.814 2.408a8.168 8.168 0 012.408 5.814c0 2.176-.87 4.275-2.409 5.814z"
        fill="#000"
      />
      <path
        d="M15.595 13.19l-2.034-.583a.758.758 0 00-.75.198l-.497.506a.74.74 0 01-.806.17c-.962-.39-2.986-2.189-3.502-3.089a.74.74 0 01.058-.82l.434-.563a.758.758 0 00.094-.77l-.856-1.935a.758.758 0 00-1.184-.271c-.568.48-1.241 1.21-1.323 2.018-.144 1.425.467 3.221 2.778 5.378 2.67 2.492 4.808 2.821 6.2 2.484.79-.191 1.42-.958 1.818-1.586a.758.758 0 00-.43-1.136z"
        fill="#000"
      />
    </svg>
  )
}
